import { tx } from '@transifex/native';
import { useEffect, useState } from 'react';

import { useSystemLocale, getTransifexLocale } from '@/modules/localization';

/**
 * Hook to initialize language settings based on system locale
 * This hook ensures Transifex uses the system locale preference
 */
export const useLanguageSetting = () => {
  const systemLocale = useSystemLocale();

  // For English (95% of users): ready immediately — no delay, no blank screen.
  // For Spanish (5%): wait for tx.setCurrentLocale to resolve before rendering.
  // This prevents the race where TRANSLATIONS_FETCHED fires before useT()
  // subscriptions are set up (useEffect runs after render), which left some
  // components stuck in English even with a warm Transifex cache.
  const transifexLocale = getTransifexLocale(systemLocale);

  const [ready, setReady] = useState(() => {
    if (transifexLocale === 'en') return true;
    return transifexLocale === tx.getCurrentLocale();
  });

  useEffect(() => {
    let cancelled = false;

    if (transifexLocale === 'en') {
      setReady(true);
      return;
    }

    if (transifexLocale === tx.getCurrentLocale()) {
      setReady(true);
      return;
    }

    setReady(false);
    tx.setCurrentLocale(transifexLocale).then((arg) => {
      if (!cancelled) setReady(true);
    });

    return () => {
      cancelled = true;
    };
  }, [transifexLocale]);

  return { ready };
};
